<template>
  <div>
    <div class="tw-mb-4">
      <div class="tw-mb-2">
        Having trouble locating familiar portal features? While the revamped portal navigation is an
        effort to make navigation more intuitive, we understand if this change might disrupt your
        daily workflow. You may temporarily revert to the legacy portal navigation until
        {{ getAlternatePortalExpiration() }}.
      </div>
      <a :href="ALTERNATE_PORTAL_HELP_LINK" target="_blank">Learn More and Provide Feedback</a>
    </div>
    <div class="tw-flex tw-flex-col tw-items-center">
      <Btn @click="toAlternatePortal" :variant="btnVariant" class="tw-mb-2">
        Temporarily Enable Legacy Navigation
      </Btn>
      <div>Available until {{ getAlternatePortalExpiration() }}</div>
    </div>
  </div>
</template>

<script>
import {
  redirect as alternatePortalRedirect,
  enable as enableAlternatePortal,
  getExpiration as getAlternatePortalExpiration,
} from "@/utils/portalMode";
import Btn from "@/components/display/Btn";
import constants from "@/utils/constants";
import store from "@/store";

export default {
  name: "NavigationImprovementsContent",
  components: {
    Btn,
  },
  props: {
    btnVariant: {
      type: String,
      default: "secondary",
    },
  },
  setup: () => {
    const toAlternatePortal = () => {
      store.dispatch("analytics/send", {
        name: "structured",
        data: {
          action: "portalMode_toggled",
          category: "portal",
          label: "alternate",
        },
      });
      enableAlternatePortal();
      alternatePortalRedirect();
    };

    return {
      ALTERNATE_PORTAL_HELP_LINK: constants.LINKS.NEXCESS.KB.ALTERNATE_PORTAL,
      getAlternatePortalExpiration,
      toAlternatePortal,
    };
  },
};
</script>
